import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const MediumCompass = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.00002 0.319946C10.06 0.319946 11.99 1.11995 13.44 2.57995C14.89 4.03995 15.69 5.97995 15.69 8.02995C15.69 10.0799 14.88 12.0199 13.43 13.4699C11.98 14.9299 10.04 15.7299 7.99002 15.7299C5.94002 15.7299 4.00002 14.9199 2.55002 13.4699C-0.449979 10.4599 -0.449979 5.57995 2.56002 2.57995C4.01002 1.11995 5.94002 0.319946 8.00002 0.319946ZM6.10999 6.52005C6.16999 6.34005 6.30999 6.20005 6.48999 6.14005L10.57 4.78005C11 4.63005 11.38 5.02005 11.24 5.45005L9.87999 9.53005C9.81999 9.71005 9.67999 9.85005 9.49999 9.91005L5.41999 11.2701C4.98999 11.4201 4.60999 11.0301 4.74999 10.6001L6.10999 6.52005ZM8.00003 7.05005C7.46431 7.05005 7.03003 7.48433 7.03003 8.02005C7.03003 8.55577 7.46431 8.99005 8.00003 8.99005C8.53575 8.99005 8.97003 8.55577 8.97003 8.02005C8.97003 7.48433 8.53575 7.05005 8.00003 7.05005Z",
            fill: "currentColor"
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M8 15.02C11.866 15.02 15 11.886 15 8.02002C15 4.15403 11.866 1.02002 8 1.02002C4.13401 1.02002 1 4.15403 1 8.02002C1 11.886 4.13401 15.02 8 15.02Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round",
                    mask: "url(#medium_compass_line)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M6.10999 6.52005L4.74999 10.6001C4.60999 11.0301 4.98999 11.4201 5.41999 11.2701L9.49999 9.91005C9.67999 9.85005 9.81999 9.71005 9.87999 9.53005L11.24 5.45005C11.38 5.02005 11 4.63005 10.57 4.78005L6.48999 6.14005C6.30999 6.20005 6.16999 6.34005 6.10999 6.52005Z",
                    fill: "currentColor",
                    mask: "url(#medium_compass_line)"
                }),
                /*#__PURE__*/ jsxs("mask", {
                    id: "medium_compass_line",
                    children: [
                        /*#__PURE__*/ jsx("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M8.00003 8.99005C8.53575 8.99005 8.97003 8.55577 8.97003 8.02005C8.97003 7.48433 8.53575 7.05005 8.00003 7.05005C7.46431 7.05005 7.03003 7.48433 7.03003 8.02005C7.03003 8.55577 7.46431 8.99005 8.00003 8.99005Z",
                            fill: "black"
                        })
                    ]
                })
            ]
        })
    });
};

export { MediumCompass as default };
